import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import VerificationPage from '@/pages/Verification/VarificationPage.vue'
import SuccessfulVerificationPage from '@/pages/SuccessfulVerification/SuccessfulVerification.vue'
import EmailConfirmation from '@/pages/EmailConfirmation/EmailConfirmation.vue'
import PhoneConfirmation from '@/pages/PhoneConfirmation/PhoneConfirmation.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/verification',
    name: 'Verification',
    component: VerificationPage,
    meta: { title: 'Synergy LK' },
  },
  {
    path: '/succsess',
    name: 'success_verification',
    component: SuccessfulVerificationPage,
    meta: { title: 'Synergy LK' },
  },
  {
    path: '/email/confirmation',
    name: 'email_confirmation',
    component: EmailConfirmation,
    meta: { title: 'Synergy LK' },
  },
  {
    path: '/phone/confirmation/:code',
    name: 'phone_confirmation',
    component: PhoneConfirmation,
    meta: { title: 'Synergy LK' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

export default router
